import { createReducer } from 'services/reduxHelpers'
import { authTypes } from 'reduxModules/actions/AuthActions'

/* ------------- Initial State ------------- */

export const initialState = {
  login: null,
  password: null,
  signedIn: false,
  isLoading: false
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [authTypes.EMAIL_SIGN_IN_ATTEMPT]: () => ({
    isLoading: true,
    signedIn: false
  }),
  [authTypes.EMAIL_SIGN_IN_SUCCESS]: (_, { data }) => ({
    ...data,
    signedIn: true,
    isLoading: false
  }),
  [authTypes.EMAIL_SIGN_IN_FAILURE]: () => ({
    signedIn: false,
    isLoading: false
  }),

  [authTypes.SIGN_OUT_SUCCESS]: () => ({
    ...initialState
  })
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/AuthReducer.js